var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTranning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2386ca;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1004.624,538.994l2.441-2.515a1.161,1.161,0,0,1,1.653-.012l31.107,31.07a1.149,1.149,0,0,1-.007,1.635l-2.506,2.459a1.153,1.153,0,0,1-1.623-.007l-31.052-31.015A1.151,1.151,0,0,1,1004.624,538.994Z",
    transform: "translate(-980.685 -532.662)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M970.913,638.56l-2.41,2.49a1.154,1.154,0,0,1-1.644.013l-31.13-31.1a1.149,1.149,0,0,1,.012-1.64l2.483-2.407a1.153,1.153,0,0,1,1.617.011L970.9,636.945A1.15,1.15,0,0,1,970.913,638.56Z",
    transform: "translate(-931.65 -582.117)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1065.585,552.4l-23.911-23.88a1.15,1.15,0,0,1,0-1.632l2.484-2.46a1.152,1.152,0,0,1,1.626,0l23.916,23.887a1.15,1.15,0,0,1-.006,1.634l-2.489,2.451A1.153,1.153,0,0,1,1065.585,552.4Z",
    transform: "translate(-1007.041 -524.095)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M951.151,668.083l-2.663,2.639a1.153,1.153,0,0,1-1.627,0l-24.1-24.075a1.149,1.149,0,0,1,0-1.627l2.652-2.654a1.153,1.153,0,0,1,1.631,0l24.116,24.086A1.154,1.154,0,0,1,951.151,668.083Z",
    transform: "translate(-922.419 -608.057)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1019.535,612.438l-8.081,8.093a1.151,1.151,0,0,1-1.629,0l-6.1-6.08a1.15,1.15,0,0,1,0-1.628l8.091-8.1a1.153,1.153,0,0,1,1.632,0l6.088,6.087A1.148,1.148,0,0,1,1019.535,612.438Z",
    transform: "translate(-980.035 -581.26)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1097.61,535.639l1.29-1.233a1.153,1.153,0,0,1,1.614.018l6.03,6.048a1.149,1.149,0,0,1-.02,1.643l-1.255,1.2a1.154,1.154,0,0,1-1.61-.015l-6.065-6.013A1.151,1.151,0,0,1,1097.61,535.639Z",
    transform: "translate(-1046.833 -531.208)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M943.008,706.591l-1.23,1.251a1.155,1.155,0,0,1-1.64.005l-6.1-6.106a1.149,1.149,0,0,1,.006-1.63l1.239-1.228a1.155,1.155,0,0,1,1.629,0L943,704.969A1.152,1.152,0,0,1,943.008,706.591Z",
    transform: "translate(-930.45 -648.3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranning);
export default __webpack_public_path__ + "static/media/tranning.96ddb8cd.svg";
export { ForwardRef as ReactComponent };